export const paintBrush = "editor/tools/PAINT_BRUSH";
export const tileStamp = "editor/tools/TILE_STAMP";
export const eraser = "editor/tools/ERASER";
export const eyeDropper = "editor/tools/EYE_DROPPER";
